import React from 'react';

import { ConfirmDialog, LoadingOverlay, Typography } from '@occc/ui-design-system';

type OpenExperienceModalProps = {
  isOpen: boolean;
  isLoading: boolean;
  onHide: () => void;
  onOpenExperienceClick: () => void;
};

export const OpenExperienceModal = ({
  isOpen,
  isLoading,
  onHide,
  onOpenExperienceClick,
}: OpenExperienceModalProps) => {
  return (
    <ConfirmDialog
      dialogTitle='Open Experience App as Member'
      open={isOpen}
      onClose={onHide}
      fullWidth={true}
      confirmButtonText='Open Experience'
      confirmButtonProps={{ onClick: onOpenExperienceClick }}
    >
      {isLoading && <LoadingOverlay />}

      <Typography>
        You are about to initiate a session as this member. Do not do this without the member’s
        explicit approval and do not make any changes to this member’s account.
      </Typography>
    </ConfirmDialog>
  );
};
